import menu from "@/data/menu.json";
import formatMenu from "@/utils/formatMenu";
export const getPopularTramites = () => {
  const formatted = formatMenu(menu);

  return formatted.flatMap(item =>
    (item.children ?? []).filter(child => child.popular === true)
  );
}; 